import { Grid } from '@material-ui/core';
import { Document } from '@roc/feature-types';
import { Button, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import TitleAgentV2 from './titleAgentV2';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { WithDocumentActions } from '../../../utils/withDocumentActions';

export type TitleAgentV2DialogProps = {
  open?: boolean;
  onClose?: () => void;
  loanId: any;
  document: Document;
};

export const TitleAgentV2Dialog = observer((props: TitleAgentV2DialogProps) => {
  const { open, onClose, loanId, document } = props;
  const { documentStore } = useDocumentStore();
  const { documentFormStore, loanStore } = documentStore;
  const { titleAgentV2Store } = documentFormStore;
  const taskId = document?.taskId;
  const lenderId = loanStore.loanDetails?.lenderId;

  const onSubmit = () => {
    titleAgentV2Store.submit(document, loanId);
  };

  useEffect(() => {
    if (open) {
      titleAgentV2Store.initForm(loanId, document?.status);
    }
  }, [open]);

  // Fallback: if loanDetails loaded asynchronously after the dialog opened, fetch companies now.
  useEffect(() => {
    if (open && lenderId && titleAgentV2Store.titleCompanies.length === 0 && !titleAgentV2Store.loading) {
      titleAgentV2Store.fetchTitleCompanies();
    }
  }, [lenderId]);

  const getActions = () => {
    return (
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <WithDocumentActions
            component={Button}
            document={document}
            onClick={onSubmit}
            disabled={!titleAgentV2Store.canSubmit}
            color="primary"
            variant="contained"
            testId="confirm"
          >
            Submit
          </WithDocumentActions>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Title Agent"
          maxWidth="lg"
          handleClose={onClose}
          dialogContent={<TitleAgentV2 store={titleAgentV2Store} />}
          dialogActions={getActions()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Title Agent"
          maxWidth="lg"
          handleClose={onClose}
          dialogContent={<TitleAgentV2 store={titleAgentV2Store} />}
          dialogActions={getActions()}
        />
      )}
    </>
  );
});

export default TitleAgentV2Dialog;
